import { CSSProperties } from 'react'

import classNames from 'classnames'

import { getLastElement } from '@local/utils'

import styles from './RollingCountAnimation.module.scss'

export interface RollingCountAnimationProps {
  rollingNumbers: number[]
  rolling: boolean
  durationSeconds?: number
  height?: number
  insetShadow?: boolean
}
const RollingCountAnimation = ({
  rollingNumbers,
  rolling,
  durationSeconds = 1,
  height = 20,
  insetShadow = false,
}: RollingCountAnimationProps) => {
  const [firstNumber] = rollingNumbers
  const middleNumbers = rollingNumbers.slice(1, -1)
  const finalNumber = getLastElement(rollingNumbers)

  const rollingCount = middleNumbers.length + 1

  const rollerStyle: CSSProperties = {
    height,
    lineHeight: `${height}px`,
    transitionDuration: `${durationSeconds}s`,
    ...(rolling && rollingNumbers.length > 1 && { transform: `translateY(-${rollingCount * height}px)` }),
  }

  return (
    <div className={classNames(styles.rolling_area, { [styles.type_with_shadow]: insetShadow })} style={{ height }}>
      <ul className={styles.roller} style={rollerStyle}>
        <li>{firstNumber}</li>
        {middleNumbers.map(rollingNumber => (
          <li key={rollingNumber}>{rollingNumber}</li>
        ))}
        <li>{finalNumber}</li>
      </ul>
    </div>
  )
}

export default RollingCountAnimation
